<template>
  <el-dialog
    title="缴费详情"
    :visible.sync="dialogVisible"
    width="45%"
    @close="cancel"
  >
    <div class="memberquery">
      <div class="box-contain">
        <div class="info-box-label">缴费单号：</div>
        <div class="info-box-value">{{dataForm.OrderNo}}</div>
      </div>
      <div class="box-contain">
        <div class="info-box-label">会员名称：</div>
        <div class="info-box-value">{{dataForm.Name}}</div>
      </div>
      <div class="box-contain">
        <div class="info-box-label">会员级别：</div>
        <div class="info-box-value">{{showLevel(dataForm.Level)}}</div>
      </div>
      <div class="box-contain">
        <div class="info-box-label">金额(元)：</div>
        <div class="info-box-value">{{dataForm.Amount}}</div>
      </div>
      <div class="box-contain">
        <div class="info-box-label">缴费时间：</div>
        <div class="info-box-value">{{dataForm.BankReceiveTime * 1000 | formatDate}}</div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { formatData } from "@/utils/index";
export default {
  name: "query",
  props: {
    dataForm: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      dialogVisible: true,
    };
  },
  mounted() {},
  methods: {
    cancel() {
      this.$emit("formCallBack", null);
    },
    //会员等级
    showLevel(level) {
      return formatData(level, this.memberLevel);
    },
  }
};
</script>
<style lang="scss" scoped>
.memberquery {
  padding: 0.2rem;
  .box-contain {
    width: 100%;
    display: flex;
    height: auto;
    line-height: 40px;
    border-bottom: 1px dashed #e6e6e6;
    .info-box-label {
      flex: 0.15;
      color: #333;
      text-align: right;
    }
    .info-box-value {
      padding-left: 20px;
      flex: 0.85;
      color: #3c3c3c;
      text-align: left;
    }
  }
}
</style>